+function($) {

  window.SarahFlint = window.SarahFlint || {};
  window.SarahFlint.State = function(product, variantIdReader) {
    this._product = product;
    this.selectedVariantId = variantIdReader;
    this._eventHandlers = {
      'onSizeChange': [],
      'onColorChange': []
    };
  }

  window.SarahFlint.State.prototype = {
    product: function() {
      return this._product;
    },

    selectedOptions: function() {
      var variant = this.selectedVariant();
      if (!variant) {
        return null;
      }
      var options = variant.options.slice(0);
      options.size = options[0];
      options.color = options[1];
      return options;
    },

    selectedVariant: function() {
      var that = this;
      var selectedVariantId = this.selectedVariantId();
      return this.product().variants.find(function(v) {
        return v.id === selectedVariantId;
      });
    },

    onSizeChange: function(handler) {
      addEventHandler(this, 'onSizeChange', handler);
    },

    onColorChange: function(handler) {
      addEventHandler(this, 'onColorChange', handler);
    },

    triggerColorUpdate: function() {
      triggerEvent(this, 'onColorChange');
    },

    triggerSizeUpdate: function() {
      triggerEvent(this, 'onSizeChange');
    }
  };


  //
  // Private
  //

  function addEventHandler(self, evt, handler) {
    var handlerList = self._eventHandlers[evt];
    if (!handlerList) {
      throw new Error("There's no event called `" + evt + "`");
    }
    handlerList.push(handler);
  }

  function triggerEvent(self, evt) {
    var handlerList = self._eventHandlers[evt];
    if (!handlerList) {
      throw new Error("There's no event called `" + evt + "`");
    }
    handlerList.forEach(function(handler){ handler(); });
  }

}(jQuery);
